import {Component} from "react";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import AppCreateNewIcon from "../../../media/app-images/AppCreateNewIcon.mjs";
import Glob from "../../../libs/Glob.mjs";
import AppSimulationIcon from "../../../media/app-images/AppSimulationIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import "./SimulationFlow.css";
import SimulationFlowInfo from "./SimulationFlowInfo.mjs";
import AppEditIcon from "../../../media/app-images/AppEditIcon.mjs";
import SimulationFlowProgress from "./SimulationFlowProgress.mjs";
import AppSimStatusInfoIcon from "../../../media/app-images/AppSimStatusInfoIcon.mjs";
import AppSimStatusSettingsIcon from "../../../media/app-images/AppSimStatusSettingsIcon.mjs";
import AppSimStatusReadyIcon from "../../../media/app-images/AppSimStatusReadyIcon.mjs";
import AppSimStatusRunningIcon from "../../../media/app-images/AppSimStatusRunningIcon.mjs";
import AppSimStatusOverIcon from "../../../media/app-images/AppSimStatusOverIcon.mjs";
import SimulationFlowSettings from "./SimulationFlowSettings.mjs";
import SimulationFlowReady from "./SimulationFlowReady.mjs";
import SimulationFlowRunning from "./SimulationFlowRunning.mjs";
import SimulationFlowOver from "./SimulationFlowOver.mjs";

const prefix = 'SimulationFlow';

const SimulationFlow = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			step: Glob.getPageParam("step"),
			simul: {info: { type: 1, priority: 3, cycle: 1 }},
			update: Date.now()
		}
		this.uid = Glob.generateUid(prefix);
		this.loadSimulationInfo = this.loadSimulationInfo.bind(this);
		this.parseSimulationInfo = this.parseSimulationInfo.bind(this);
		this.renderStep = this.renderStep.bind(this);
		this.renderDefaultStep = this.renderDefaultStep.bind(this);
		this.renderFlow = this.renderFlow.bind(this);
		this.flowSteps = this.flowSteps.bind(this);
	}
	componentDidMount() {
		Glob.setStatus('pageTitle', ['Simulations',(this.state.editing ? "Edit Simulation" : "New Simulation")]);
		Glob.setStatus('pageIcon', <AppSimulationIcon />);
		Glob.register('currentPage', cp => {
			const s = cp?.params?.step;
			if ( s !== this.state.step ) this.setState({ step: s });
		}, this.uid );
		setTimeout( this.loadSimulationInfo );
	}
	componentWillUnmount() {
		Glob.deregister( this.uid );
	}
	loadSimulationInfo() {
		const payload = {};
		const id = Number(this.state.editing);
		if ( id && typeof id === 'number') payload.id = id;
		appLib.api('simul/info',payload).then(
			this.parseSimulationInfo
		).catch( err => {
			console.log(err);
		})
	}
	parseSimulationInfo(res) {
		return new Promise( resolve => {
			const ns = { update: Date.now() };
			if ( res.id ) ns.onEdit = res.id;
			if ( res.lists ) {
				/** come from info, not from get or any save operation */
				ns.lists = res.lists;
				if ( res.saved ) {
					ns.simul = Glob.clone(res.saved);
					ns.saved = res.saved;
				}
			} else {
				ns.simul = Glob.clone(res);
				ns.saved = res;
			}
			this.setState(ns, resolve );
		})
	}
	renderDefaultStep() {
		return null;
	}
	renderStep( upd ) {
		if ( ! upd ) upd = this.state.update;
		const props = {
			updateTime: upd,
			editing: this.state.editing,
			peri: Glob.clone(this.state.peri),
			afterSave: this.parseSimulationInfo
		};
		switch ( this.state.step ) {
			case "info":
				return (
					<SimulationFlowInfo
						key={'info-'+upd}
						saved={ Glob.clone(this.state.saved) }
						simul={ Glob.clone(this.state.simul) }
						lists={ this.state.lists }
						{ ...props }
					/>);
			case "settings":
				return (
					<SimulationFlowSettings
						key={'settings'+upd}
						simul={ Glob.clone(this.state.saved) }
						{ ...props }
					/>
				);
			case "ready":
				return (
					<SimulationFlowReady
						key={'ready'+upd}
						simul={ Glob.clone(this.state.saved) }
						lists={ this.state.lists }
						{ ...props }
					/>
				);
			case "running":
				return (
					<SimulationFlowRunning
						simul={ Glob.clone(this.state.saved) }
						{ ...props }
					/>
				);
			case "over":
				return (
					<SimulationFlowOver
						simul={ Glob.clone(this.state.saved) }
						{ ...props }
					/>
				);
			default: return this.renderDefaultStep( upd );
		}
	}
	flowSteps() {
		return [
			{threshold:10, label: "info", icon: <AppSimStatusInfoIcon />, info: "Info" },
			{threshold:40, label: "settings", icon: <AppSimStatusSettingsIcon />, info: "SimulationSettings" },
			{threshold:50, label: "ready", icon: <AppSimStatusReadyIcon />, info: "Simulation start" },
			{threshold:80, label: "running", icon: <AppSimStatusRunningIcon />, info: "Running" },
			{threshold:90, label: "over", icon: <AppSimStatusOverIcon />, info: "Simulation completed" }
		];
	}
	renderFlow( upd ) {
		if ( ! upd ) upd = this.state.update;
		return (
			<SimulationFlowProgress
				key={'progress-'+upd}
				editing={ this.state.editing }
				step={ this.state.step }
				steps={ this.flowSteps() }
				status={ this.state.saved?.status }
			/>
		);
	}
	render() {
		if ( ! this.state.lists ) return null;
		if ( this.state.simul.id ) {

		}
		return(
			<SliderPanel
				id={ this.uid }
				title={<TextLabel value={ this.state.editing ? "Edit Simulation" : "New Simulation"} />}
				icon={ this.state.editing ? <AppEditIcon /> : <AppCreateNewIcon />}
				className={prefix}
			>
				{ this.renderFlow( this.state.update ) }
				{ this.renderStep( this.state.update ) }
			</SliderPanel>
		)
	}
}

export default SimulationFlow;